const LiveBadge = () => {
  return (
    <h3 className="live-badge">
      LIVE
    </h3>
  );
};

export default LiveBadge;
